module.exports = __webpack_public_path__ + "static/img/parking-icon.ce48e475.svg";